import { Badge, BadgeProps } from "@chakra-ui/react";
import { useGetTransparency } from "utils/colorHooks";

export default function ArchivedBadge({ sx, ...rest }: BadgeProps) {
  const getTransparency = useGetTransparency();
  return (
    <Badge
      variant="outline"
      {...rest}
      sx={{
        ...sx,
        "tr[aria-selected=true] &": {
          "--badge-color": getTransparency("white", 0.85),
        },
      }}
    >
      Archived
    </Badge>
  );
}
